import {Component, OnInit, ViewChild} from '@angular/core';
import DataSource from 'devextreme/data/data_source';
import {Tag, Taggable, User} from 'shared';
import {TagService} from '../../stores/tag.service';
import {Subject} from 'rxjs';
import {DxDataGridComponent} from 'devextreme-angular';
import DxDataGrid from 'devextreme/ui/data_grid';

@Component({
  selector: 'app-tags-grid',
  templateUrl: './tags-grid.component.html',
  styleUrls: ['./tags-grid.component.scss']
})
export class TagsGridComponent implements OnInit {

  @ViewChild(DxDataGridComponent)
  grid: DxDataGridComponent;

  ds: DataSource;
  canEdit: boolean;
  canAdd: boolean;
  canDelete: boolean;
  tagTypes = [
    {id: 100, name: 'RFID'},
    {id: 200, name: 'BLE'},
  ];
  tagCategories = [
    {id: 10, name: 'Intervention Outils'},
    {id: 20, name: 'Intervention Machines'},
    {id: 30, name: 'Intervention Transport'},
    {id: 40, name: 'Identification Chauffeur'},
  ];

  private editSaveClick: Subject<DxDataGrid> = new Subject<DxDataGrid>();
  editSaveClick$ = this.editSaveClick.asObservable();

  private editCancelClick: Subject<DxDataGrid> = new Subject<DxDataGrid>();
  editCancelClick$ = this.editCancelClick.asObservable();

  editToolbarItems = [{
    toolbar: 'bottom',
    location: 'after',
    widget: 'dxButton',
    options: {
      text: 'Sauvegrader',
      onClick: (e) => {
        this.editSaveClick.next(this.grid.instance);
      }
    }
  }, {
    toolbar: 'bottom',
    location: 'after',
    widget: 'dxButton',
    options: {
      text: 'Annuler',
      onClick: (e) => {
        this.editCancelClick.next(this.grid.instance);
      }
    }
  }];
  private expandedAlertRowKey;
  private cloned: Tag | null;
  taggable: Taggable;
  taggableEl: HTMLElement;
  taggableVisible: boolean;

  constructor(
    private tagService: TagService,
    public user: User
  ) {

    // Data source
    this.ds = tagService.newDataSource();

    // Permissions
    this.canEdit = user.can('edit tags');
    this.canAdd = user.can('add tags');
    this.canDelete = user.can('delete tags');

    // Bindings
    this.codeValidation = this.codeValidation.bind(this);
    this.showAttributes = this.showAttributes.bind(this);
    this.addTagAttr = this.addTagAttr.bind(this);
    this.cloneTag = this.cloneTag.bind(this);
    this.checkClone = this.checkClone.bind(this);
  }

  ngOnInit(): void {
  }

  codeValidation(params: any) {
    return this.tagService.checkCode(params.value, params.data?.id).toPromise();
  }

  showAttributes(e: any) {
    e.component.collapseAll(-1);
    if (this.expandedAlertRowKey === e.row.key) {
      this.expandedAlertRowKey = 0;
      return;
    }
    e.component.expandRow(e.row.key);
    this.expandedAlertRowKey = e.row.key;
  }

  addTagAttr(index: any) {
    this.grid.instance.editRow(index);
  }

  checkClone(e: any) {
    if (!this.cloned) {
      return;
    }

    e.data = Object.assign({}, this.cloned);
    delete e.data.id;
    delete e.data.code;

    this.cloned = null;
  }

  cloneTag(e: any) {
    this.cloned = e.row.data;
    this.grid.instance.addRow();
  }

  showTaggable(e: MouseEvent, data: Tag) {
    e.preventDefault();
    if (!data.taggable_id) {
      return;
    }
    this.tagService.taggable(data.id).subscribe((t) => {
      this.taggable = t;
      this.taggableEl = e.target as HTMLElement;
      this.taggableVisible = true;
    });
  }
}
